import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import { Box, Spinner, Center } from "@chakra-ui/react";

export const AuthSuccess = () => {
  const navigate = useNavigate();
  const { googleAuth } = useAuthStore();

  useEffect(() => {
    const handleAuthSuccess = async () => {
      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");

      if (token) {
        try {
          await googleAuth(token);
          navigate("/chat");
        } catch (error) {
          console.error("Error during Google auth:", error);
          navigate("/login");
        }
      } else {
        navigate("/login");
      }
    };

    handleAuthSuccess();
  }, [navigate, googleAuth]);

  return (
    <Box height="100vh">
      <Center height="100%">
        <Spinner size="xl" color="brand.primary" />
      </Center>
    </Box>
  );
};
